import { OidcClient, UserManager, User } from "oidc-client";
import { Action } from "../store";

const config = {
    // the URL of our identity server
    authority: process.env.REACT_APP_AUTHORITY_ENDPOINT,
    // this ID maps to the client ID in the identity client configuration
    client_id: "bureauportal",
    // Secret
    client_secret: "9kXNuZZutewX",
    // URL to redirect to after login
    redirect_uri: process.env.REACT_APP_REDIRECT_ENDPOINT, 
    response_type: "code",
    response_mode: "query",
    // the scopes or resources we would like access to
    scope: "openid profile csec_info csec_api", 
    // URL to redirect to after logout
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_ENDPOINT,
    // Silent Renew Control
    silent_redirect_uri: process.env.REACT_APP_SILENT_RENEW_ENDPOINT,
    automaticSilentRenew: true
};

// Initialize
const userManager = new UserManager(config)

////////////
// EVENTS //
////////////

userManager.events.addUserLoaded(function (user) {
    console.log("User loaded", user);
    // Debug flag
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') { showTokens(); }
});
userManager.events.addUserUnloaded(function () {
    console.log("User unloaded");
});
userManager.events.addAccessTokenExpiring(function () {
    console.log("token expiring...");
});
userManager.events.addSilentRenewError(function (err) {
    console.log("Silent renew error: " + err.message);
    //signinRedirect();
});

// User
let userMgrUser: User | null = null;

///////////////
// Functions //
///////////////
export async function signInRedirect() {
    await signinRedirectAsync();
}
export async function signInRedirectS(s: any) {
    await signinRedirectAsyncS(s);
}

export function signinRedirectAsync() {
    return userManager.signinRedirect()
}

export function signinRedirectAsyncS(s: any) {
    return userManager.signinRedirect({ state: s })
}

export async function signinRedirectCallback(dispatch: React.Dispatch<Action>, url?: string | undefined) {
    await signinRedirectCallbackAsync(dispatch);
}

export function signinRedirectCallbackAsync(dispatch: React.Dispatch<Action>, url?: string | undefined) {
    return userManager.signinRedirectCallback().then((user: User) => {
        console.log(user);
        user && dispatch({ type: "set questionnaire", value: user.state });
        userMgrUser = user;
    });
}

export async function signoutRedirect() {
    await signoutRedirectAsync()
}

export function signoutRedirectAsync() {
    userManager.clearStaleState()
    userManager.removeUser()
    return userManager.signoutRedirect()
}

export async function signoutRedirectCallback(url?: string | undefined) {
    await signoutRedirectCallbackAsync();
}

export function signoutRedirectCallbackAsync(url?: string | undefined) {
    userManager.clearStaleState()
    userManager.removeUser()
    return userManager.signoutRedirectCallback()
}

export async function renewAccessToken() {
    await renewAccessTokenAsync();
}

export function renewAccessTokenAsync() {
    return userManager.signinSilentCallback();
}

export async function getUserInfo() {
    return await getUserInfoAsync();
}

export function getUserInfoAsync() {
    return userManager.getUser()
}


////////////////////////
// Internal Functions //
////////////////////////

export function showTokens() {
    userManager.getUser().then(function (user) {
        if (user) {
            extractToken(user);
        }
        else {
            console.log("Not logged in");
        }
    });
}

function extractToken(data: string | User) {
    if (data && typeof data === 'string') {
        try {
            data = JSON.parse(data);
        }
        catch (e) { }
    }
    if (data && typeof data !== 'string') {
        data = JSON.stringify(data, null, 2);
    }
    console.log(data);
}


export default userManager